export const hourlyWeatherPageTestIDs = {
  hourlyWeatherPage: 'hourly_weather_page',
  hourlyWeatherHeaderFrame: 'hourly_weather_header_frame',
  hourlyWeatherHeaderDate: 'hourly_weather_page_hourly_weather_header_date',
  hourlyWeatherHeaderLabel: 'hourly_weather_page_hourly_weather_header_label',
  hourlyWeatherSubheaderLabel: 'hourly_weather_page_hourly_weather_subheader_label',
  hourlyWeatherTile: 'hourly_weather_page_hourly_weather_tile',
  hourlyWeatherTilesList: 'hourly_weather_page_hourly_weather_tiles_list',
  hourlyWeatherTopRow: 'hourly_weather_page_top_row',
  hourTile: 'hourly_weather_page_hour_tile',
  pipWidget: 'hourly_weather_page_picture_in_picture_widget',
  hourlyWeatherConditionsWidget: 'hourly_weather_conditions_page_hourly_weather_widget',
  hourlyWeatherConditionsWidgetLeft: 'hourly_weather_conditions_page_hourly_weather_widget_left',
  hourlyWeatherConditionsWidgetRight: 'hourly_weather_conditions_page_hourly_weather_widget_right',
  hourlyWeatherWidget: {
    precipChanceText: 'hourly_weather_conditions_page_hourly_weather_widget_precip_chance_text',
    precipChanceTitleText: 'hourly_weather_conditions_page_hourly_weather_widget_precip_chance_title_text',
    qpfText: 'hourly_weather_conditions_page_hourly_weather_widget_quantitative_precipitation_forecast_text',
    qpfTitleText: 'hourly_weather_conditions_page_hourly_weather_widget_quantitative_precipitation_forecast_title_text',
    relativeHumidityText: 'hourly_weather_conditions_page_hourly_weather_widget_relative_humidity_text',
    relativeHumidityTitleText: 'hourly_weather_conditions_page_hourly_weather_widget_relative_humidity_title_text',
    temperatureDewPointText: 'hourly_weather_conditions_page_hourly_weather_widget_temperature_dew_point_text',
    temperatureDewPointTitleText:
      'hourly_weather_conditions_page_hourly_weather_widget_temperature_dew_point_title_text',
    temperatureFeelsLikeLabelText: 'hourly_weather_conditions_page_hourly_weather_widget_feels_like_label_text',
    temperatureFeelsLikeText: 'hourly_weather_conditions_page_hourly_weather_widget_feels_like_text',
    temperatureText: 'hourly_weather_conditions_page_hourly_weather_widget_temperature_text',
    uvIndexText: 'hourly_weather_conditions_page_hourly_weather_widget_uv_index_text',
    uvIndexTitleText: 'hourly_weather_conditions_page_hourly_weather_widget_uv_index_title_text',
    visibilityText: 'hourly_weather_conditions_page_hourly_weather_widget_visibility_text',
    visibilityTitleText: 'hourly_weather_conditions_page_hourly_weather_widget_visibility_title_text',
    visibilityUnitsText: 'hourly_weather_conditions_page_hourly_weather_widget_visibility_units_text',
    windGustText: 'hourly_weather_conditions_page_hourly_weather_widget_wind_gust_text',
    windGustTitleText: 'hourly_weather_conditions_page_hourly_weather_widget_wind_gust_title_text',
    windText: 'hourly_weather_conditions_page_hourly_weather_widget_wind_text',
    windTitleText: 'hourly_weather_conditions_page_hourly_weather_widget_wind_title_text',
    windUnitsText: 'hourly_weather_conditions_page_hourly_weather_widget_wind_units_text',
    wxPhraseText: 'hourly_weather_conditions_page_hourly_weather_widget_wx_phrase_text',
  },
};
